import { render, staticRenderFns } from "./safetyActionTarget.vue?vue&type=template&id=d1b6c94c"
import script from "./safetyActionTarget.vue?vue&type=script&lang=js"
export * from "./safetyActionTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1b6c94c')) {
      api.createRecord('d1b6c94c', component.options)
    } else {
      api.reload('d1b6c94c', component.options)
    }
    module.hot.accept("./safetyActionTarget.vue?vue&type=template&id=d1b6c94c", function () {
      api.rerender('d1b6c94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sat/safetyActionTarget.vue"
export default component.exports